// extracted by css-extract-rspack-plugin
export default {"inner":"inner-v3CuBw"};